import AboutApp from './apps/AboutApp';
import ProjectsApp from './apps/ProjectsApp';
import ResumeApp from './apps/ResumeApp';
import ContactApp from './apps/ContactApp';
import TerminalApp from './apps/TerminalApp';
import SettingsApp from './apps/SettingsApp';
import ArcadeApp from './apps/ArcadeApp';

// Registry of every "app" the OS-mode desktop can open.
// showOnDesktop -> gets an icon on the desktop itself
// showInDock    -> gets an icon in the dock
// defaultSize / minSize are in px, enforced by Window.jsx
const apps = [
	{
		id: 'about',
		title: 'About Me',
		icon: 'fa-solid fa-user',
		component: AboutApp,
		defaultSize: { width: 560, height: 500 },
		minSize: { width: 360, height: 340 },
		showOnDesktop: true,
		showInDock: true,
	},
	{
		id: 'projects',
		title: 'Projects',
		icon: 'fa-solid fa-folder',
		component: ProjectsApp,
		defaultSize: { width: 800, height: 540 },
		minSize: { width: 480, height: 360 },
		showOnDesktop: true,
		showInDock: true,
	},
	{
		id: 'resume',
		title: 'Resume.pdf',
		icon: 'fa-solid fa-file-lines',
		component: ResumeApp,
		defaultSize: { width: 520, height: 620 },
		minSize: { width: 360, height: 420 },
		showOnDesktop: true,
		showInDock: true,
	},
	{
		id: 'contact',
		title: 'Mail',
		icon: 'fa-solid fa-envelope',
		component: ContactApp,
		defaultSize: { width: 660, height: 560 },
		minSize: { width: 420, height: 420 },
		showOnDesktop: false,
		showInDock: true,
	},
	{
		id: 'terminal',
		title: 'Terminal',
		icon: 'fa-solid fa-terminal',
		component: TerminalApp,
		defaultSize: { width: 620, height: 420 },
		minSize: { width: 360, height: 260 },
		showOnDesktop: false,
		showInDock: true,
	},
	{
		id: 'settings',
		title: 'System Settings',
		icon: 'fa-solid fa-gear',
		component: SettingsApp,
		defaultSize: { width: 560, height: 460 },
		minSize: { width: 420, height: 360 },
		showOnDesktop: false,
		showInDock: true,
	},
	{
		id: 'arcade',
		title: 'Arcade',
		icon: 'fa-solid fa-gamepad',
		component: ArcadeApp,
		defaultSize: { width: 720, height: 560 },
		minSize: { width: 420, height: 360 },
		showOnDesktop: true,
		showInDock: true,
	},
];

export default apps;

export const getApp = id => apps.find(a => a.id === id);
